import "core-js/modules/es6.array.index-of";
import { removeIndexFromArray } from './removeIndexFromArray.js';

function removeItemFromArray(array, item) {
  var idx = array.indexOf(item);
  return removeIndexFromArray(array, idx);
}

export { removeItemFromArray };